import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePasswordOperation } from '../../hooks/usePasswordOperation';
import { useValidation } from '../../hooks/useValidation';
import { emailValidation } from '../../utils/validationUtils';
import { ErrorHandler } from '../../utils/errorHandler';
import ForgotPasswordLayout from './components/ForgotPasswordLayout';
import ForgotPasswordForm from './components/ForgotPasswordForm';

const ForgotPasswordContainer: React.FC = () => {
  const navigate = useNavigate();
  const { requestPasswordReset, requestLoading, requestError } = usePasswordOperation();

  const [emailSent, setEmailSent] = React.useState(false);

  const validationRules = {
    email: [emailValidation],
  };

  const { getFieldProps, validateAll, errors, values } = useValidation(validationRules);

  // Processa erros usando o ErrorHandler padronizado
  const processedError = React.useMemo(() => {
    if (!requestError) return null;

    // Se já é uma string processada (vem do useRequest), retorna diretamente
    if (typeof requestError === 'string') {
      return requestError;
    }

    // Caso contrário, processa como objeto de erro
    return ErrorHandler.getGeneralError(requestError);
  }, [requestError]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateAll()) {
      return;
    }

    try {
      await requestPasswordReset(values.email);
      setEmailSent(true);
    } catch (error) {
      // Erro será tratado pelo estado requestError
      console.error('Erro ao solicitar recuperação de senha:', error);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  if (emailSent) {
    return (
      <ForgotPasswordLayout>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <h2 style={{ marginBottom: '1rem', color: '#107c10' }}>E-mail enviado!</h2>
          <p style={{ marginBottom: '2rem' }}>
            Enviamos um link de recuperação para o e-mail <strong>{values.email}</strong>.
            Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '2rem' }}>
            Não recebeu o e-mail? Verifique sua pasta de spam ou lixo eletrônico.
          </p>
          <button
            onClick={handleBackToLogin}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#0078d4',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Voltar ao Login
          </button>
        </div>
      </ForgotPasswordLayout>
    );
  }

  return (
    <ForgotPasswordLayout>
      <ForgotPasswordForm
        getFieldProps={getFieldProps}
        errors={errors}
        onSubmit={handleSubmit}
        loading={requestLoading}
        error={processedError}
        onBackToLogin={handleBackToLogin}
      />
    </ForgotPasswordLayout>
  );
};

export default ForgotPasswordContainer;